import {Flex} from "@hps/hops-react";
import {Tooltip} from "@mui/material";
import PropTypes from "prop-types";
import React from "react";

import Button from "./Button.js";
import Container from "./Container.js";
import QuantityInput from "./QuantityInput.js";
import String from "./String.js";

/**
 * Quantity picker component
 *
 * @package HOPS
 * @subpackage Components
 * @author Heron Web Ltd
 * @copyright Heritage Operations Processing Limited
 */
class Quantity extends React.PureComponent {

	/**
	 * Render.
	 * 
	 * @return {ReactNode}
	 */
	render() {
		return (
			<Flex>
				<Container
					alignItems="center"
					columnar={true}
					columns={(!this.props.noDefaultColumns ? "repeat(3, 1fr)" : undefined)}
					gap={0.5}
					justifyContent={this.props.justifyContent}
					justifyItems="center">
					<Tooltip arrow={true} title={(!this.props.noTooltips ? this.negTooltip : "")}>
						<div>
							<Button
								disabled={((this.props.value <= this.props.min) || this.props.disabled)}
								label="-"
								name={this.props.name}
								noDefaultDimensions={true}
								onClick={this.props.onChange}
								style={this.constructor.qtyBtnStyles}
								value={(this.props.value - 1)}
								variant={this.props.variant} />
						</div>
					</Tooltip>
					{this.props.inlineEdit ?
						<QuantityInput
							disabled={this.props.disabled}
							maxValue={this.props.max}
							minValue={this.props.min}
							name={this.props.name}
							onChange={this.props.onChange}
							required={true}
							value={this.props.value}
							variant="outlined"
							withStartAdornment={false} /> :
						<String
							centre={true}
							color={this.props.textColor}
							str={`${this.props.value} ${(this.props.label || "")}`.trim()} />}
					<Tooltip arrow={true} title={(!this.props.noTooltips ? this.posTooltip : "")}>
						<div>
							<Button
								disabled={((this.props.value >= this.props.max) || this.props.disabled)}
								label="+"
								name={this.props.name}
								noDefaultDimensions={true}
								onClick={this.props.onChange}
								style={this.constructor.qtyBtnStyles}
								value={(this.props.value + 1)}
								variant={this.props.variant} />
						</div>
					</Tooltip>
				</Container>
				{(this.props.value >= this.props.max) && <String color="error" str={`Maximum of ${this.props.max} allowed`} textAlign="center" />}
			</Flex>
		);
	}


	/**
	 * Get the negative tooltip string.
	 * 
	 * @return {String}
	 */
	get negTooltip() {
		if (this.props.value > ((this.props.min || 0) + 1)) {
			return "Reduce Quantity";
		}
		else return "Remove from Basket";
	}


	/**
	 * Get the positive tooltip string.
	 * 
	 * @return {String}
	 */
	get posTooltip() {
		if (this.props.value < this.props.max) return "Increase Quantity";
		else if (this.props.max) return `Maximum of ${this.props.max} allowed`;
		else return "Increase Quantity";
	}


	/**
	 * Quantity button styles.
	 * 
	 * @type {Object}
	 */
	static qtyBtnStyles = {minWidth: 0};

	static propTypes = {
		inlineEdit: PropTypes.bool,
		variant: PropTypes.string
	};

	static defaultProps = {
		inlineEdit: false,
		variant: "outlined"
	};

}

export default Quantity;
